import { Maybe } from 'graphql/jsutils/Maybe'
import { IHighwayContact } from 'types/graphqlTypes'

export const getMaskedEin = (ein: string) => ein.replace(/\d(?=\d{4})/g, '*')

export const getStreet = (street1: Maybe<string>, street2: Maybe<string>) => {
  if (street1 && street2) {
    return `${street1}, ${street2}`
  }
  return street1 || street2 || 'No Data'
}

export const removeDuplicateDispatchers = (
  uniqueDispatchers: IHighwayContact[],
  dispatcher: any
) => {
  const { emailAddress, name, phone } = dispatcher
  const isDuplicate = uniqueDispatchers.some(uniqueDispatcher => {
    const {
      emailAddress: dispatcherEmail,
      name: dispatcherName,
      phone: dispatcherPhone,
    } = uniqueDispatcher

    return name === dispatcherName && emailAddress === dispatcherEmail && phone === dispatcherPhone
  })
  if (!isDuplicate) {
    uniqueDispatchers.push(dispatcher)
  }
  return uniqueDispatchers
}
